var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "19",
        viewBox: "0 0 21 21",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M15.375 4.75L13.965 6.16L16.545 8.75H6.375V10.75H16.545L13.965 13.33L15.375 14.75L20.375 9.75L15.375 4.75ZM2.375 2.75H10.375V0.75H2.375C1.275 0.75 0.375 1.65 0.375 2.75V16.75C0.375 17.85 1.275 18.75 2.375 18.75H10.375V16.75H2.375V2.75Z",
          fill: "current",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }